<template>
  <v-application>
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="pos"
          v-bind:headers="headers"
          v-bind:data="data"
          v-bind:save="save"
          v-bind:row="edit"
          ClientStatus
          v-bind:remove="remove"
          v-bind:add_button_name="'add_status'"
          v-bind:saveDisabled="!is_valid"
        >
          <v-form v-model="is_valid">
            <v-card-text>
              <v-text-field
                v-model="status.name"
                :label="$t('name')"
                :rules="[fieldRules.required]"
              />
              <v-text-field
                v-model="status.percentage"
                type="number"
                :label="$t('percent')"
                suffix="%"
                :rules="[fieldRules.required && MaxValue]"
              />
            </v-card-text>
          </v-form>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
import Userable from "../../mixins/userable";
export default {
  mixins: [Userable],
  data: () => ({
    device_edit_index: -1,
    headers: [
      { text: "Name", value: "name", align: "left" },
      { text: "Percent", value: "percentage" },
    ],
    is_valid: false,
    data: [],
    status: {
      name: null,
      percentage: 1,
      organization: "",
    },
    page: 1,
    totalPages: null,
    snackbar: false,
    MaxValue: (val) => {
      if (val > 100) return "Max 100";
      return true;
    },
  }),
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "name", align: "left" , available: true},
      { text: this.$t("percent"), value: "percentage" , available: true},
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.update();
  },
  methods: {
    async remove(items) {
      const indeces = [];
      for (const index in items) {
        indeces.push(items[index]._id);
      }
      const dalete = await this.$communicator("remove_status", {
        params: {
          indexes: indeces,
        },
      });
      if (dalete.data.statusCode == 200) {
        this.$toast.success(`${dalete.data.message}`, { timeout: 2000 });
      }
      this.update();
    },
    edit(item) {
      if (item == null) {
        this.device_edit_index = -1;
        this.status = {
          name: null,
          percentage: 1,
          organization: this.user.organization,
        };
      } else {
        this.device_edit_index = item._id;
        this.status = {
          name: item.name,
          percentage: item.percentage,
          organization: this.user.organization,
        };
      }
    },
    async update() {
      const status = this.$communicator.then(
        this,
        await this.$communicator("client_status_get", {})
      );
      if (status) {
        this.data = status.data;
      }
    },
    async save() {
      var params = this.$copy(this.status);
      if (this.device_edit_index == -1) {
        const save = await this.$communicator("client_status_create", {
          params: params,
        });
        if (save.data.statusCode == 200) {
          this.$toast.success(`${save.data.message}`, { timeout: 2000 });
        }
      } else {
        const update = await this.$communicator("client_status_update", {
          arguments: [this.device_edit_index],
          params: params,
        });
        if (update.data.statusCode == 200) {
          this.$toast.success(`${update.data.message}`, { timeout: 2000 });
        }
      }
      this.update();
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>